// AUTO-GENERATED SQL Builder (V40 Final) for PartnerApproval
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class PartnerApprovalSql {
  private ast = new SqlAst('PartnerApproval', 'partnerApproval');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public bookingPackageId: SqlField;
  public partnerVendorId: SqlField;
  public status: SqlField;
  public decidedDate: SqlField;
  public notes: SqlField;
  public booking: SqlNavHybrid;
  public bookingPackage: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public partnerVendor: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('partnerApproval', 'guid', '', 'id', 'partnerApproval_guid');
    this.bookingId = new SqlField('partnerApproval', 'bookingId', 'booking', 'id', 'partnerApproval_booking');
    this.bookingPackageId = new SqlField('partnerApproval', 'bookingPackageId', 'bookingPackage', 'id', 'partnerApproval_bookingPackage');
    this.partnerVendorId = new SqlField('partnerApproval', 'partnerVendorId', '', 'id', 'partnerApproval_partnerVendor');
    this.status = new SqlField('partnerApproval', 'status', '', 'id', 'partnerApproval_status');
    this.decidedDate = new SqlField('partnerApproval', 'decidedDate', '', 'id', 'partnerApproval_decidedDate');
    this.notes = new SqlField('partnerApproval', 'notes', '', 'id', 'partnerApproval_notes');
    this.booking = createNavHybrid('partnerApproval', 'partnerApproval_booking', 'Booking');
    this.bookingPackage = createNavHybrid('partnerApproval', 'partnerApproval_bookingPackage', 'BookingPackage');
    this.createdByUser = createNavHybrid('partnerApproval', 'partnerApproval_createdByUser', 'User');
    this.partnerVendor = createNavHybrid('partnerApproval', 'partnerApproval_partnerVendor', 'Vendor');
    this.updatedByUser = createNavHybrid('partnerApproval', 'partnerApproval_updatedByUser', 'User');
    this.id = new SqlField('partnerApproval', 'id', '', 'id', 'partnerApproval_id');
    this.isDeleted = new SqlField('partnerApproval', 'isDeleted', '', 'id', 'partnerApproval_isDeleted');
    this.createdBy = new SqlField('partnerApproval', 'createdBy', '', 'id', 'partnerApproval_createdBy');
    this.createdDate = new SqlField('partnerApproval', 'createdDate', '', 'id', 'partnerApproval_createdDate');
    this.updatedBy = new SqlField('partnerApproval', 'updatedBy', '', 'id', 'partnerApproval_updatedBy');
    this.updatedDate = new SqlField('partnerApproval', 'updatedDate', '', 'id', 'partnerApproval_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:PartnerApprovalSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:PartnerApprovalSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:PartnerApprovalSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:PartnerApprovalSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:PartnerApprovalSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:PartnerApprovalSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:PartnerApprovalSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:PartnerApprovalSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:PartnerApprovalSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:PartnerApprovalSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
